export default function PBtn({ children, onClick, full, style: sx = {}, extra: ex = {} }) {
  return (
    <button className="btn-orange" onClick={onClick} style={{ width: full ? "100%" : undefined, display: full ? "block" : "inline-flex", alignItems: "center", justifyContent: "center", ...sx, ...ex }}>
      {children}
    </button>
  );
}
